/**
 * Display glyphs for the three season currencies. Centralised so the TopNav
 * chip, the Seasons page, and the per-map leaderboard panel all render the
 * same star / cup / crown rather than re-hardcoding code points.
 */
export const STAR_GLYPH = '\u2605'; // ★ — cleared a map (loop 1)
export const CUP_GLYPH = '\u{1F3C6}'; // 🏆 — mastered infinite mode (loops 2-3)
export const CROWN_GLYPH = '\u{1F451}'; // 👑 — sitting in a map's leaderboard top 3
